import React from "react";
import useStyles from "../styles";
import {setAssayTime} from "@cabinet-packages/redux";
import {useDispatch} from "react-redux";
import moment from "moment";

const WeekView = ({week, useDay, handleChangeMonth, setSelectedTime, checked, scrollRef}) => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const [selectedDay, setSelectedDay] = useDay;

    const handleClickOnDay = (e,day) => {
        e.preventDefault();
        e.stopPropagation();

        if (day.freeHours && !checked) {
            setSelectedTime(null);
            dispatch(setAssayTime());

            if (day.current) {
                setSelectedDay(day);
            } else if (day.next) {
                setSelectedDay(day);
                handleChangeMonth(e, false, true);
            } else if (day.prev) {
                setSelectedDay(day);
                handleChangeMonth(e, true, true);
            }

            scrollRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (<div className={cl.weekWrapper}>
        {week.map((day, idx) => {
            const className = day.freeHours && !checked
                ? day.current && day.dayNum === selectedDay?.dayNum
                    ? cl.dayWrapperSelected
                    : cl.dayWrapper
                : cl.dayWrapperNotFree

            return (
                <div style={{opacity: day.current ? 1 : 0.5}} onClick={(e) => handleClickOnDay(e, day)}
                     key={idx + 'day' + day.dayNum}
                     className={className}
                >
                    {day.dayNum}
                </div>)
        })}
    </div>);
};

export default WeekView;
